import { useEffect, useState } from "react";
export function useSheetContainer(mountPortalContainer) {
    const [container, setContainer] = useState(mountPortalContainer);
    useEffect(() => {
        if (mountPortalContainer) {
            setContainer(mountPortalContainer);
            return;
        }
        if (!container) {
            const dialogElements = document.querySelectorAll(".sheet[role=dialog][data-state=open]");
            const lastDialog = dialogElements[dialogElements.length - 1];
            if (lastDialog) {
                setContainer(lastDialog);
            }
        }
    }, [container, mountPortalContainer]);
    return container;
}
//# sourceMappingURL=useSheetContainer.js.map